import { ActiveObject, Package, PackageHost, resolve } from '../../Container';
import { ContentInjector } from '../injection/ContentInjector';

export class KioskInjectMechanics extends ActiveObject {

    @resolve(ContentInjector) private injector!: ContentInjector;

    public start() {
        const query = new URLSearchParams(window.location.search);
        const data = query.get('inject');
        if (data) {
            const ddt = JSON.parse(atob(data));
            this.injector.injectNative(ddt);
        }
    }
}

export class KioskPackage implements Package {

    public install = (host: PackageHost) => host
        .register(KioskInjectMechanics, 'singleton', 'startable')
        ;
}
